import { useQuery } from '@tanstack/react-query';
import { useAtomValue } from 'jotai';
import { userAtom } from '@src/state/userAtom';
import { QUERY_KEYS } from '@src/query';
import { getSocialTopProducts } from './api';

export const useQuerySocialTopProducts = (
  params: { from?: string; to?: string; limit: number },
  enabled: boolean,
) => {
  const user = useAtomValue(userAtom);
  const groupKey = user?.group?._id ?? user?.group?.name;

  return useQuery({
    queryKey: QUERY_KEYS.socialTopProducts(params, groupKey),
    queryFn: () => getSocialTopProducts(params),
    enabled: enabled && !!user?._id && !!groupKey,
  });
};
